<template>
  <!-- <f7-page class=""> -->
  <div class="page">
    <!--bottom-toolbar></bottom-toolbar-->
    <div class="page-content">
      <page-nav-bar currentServiceName="MoneyRoad" subNavTitle="Application Settings" :returnPreviousPage="false"></page-nav-bar>
      <div class="layoutTop"/>

      <div class="container-fluid">
        <div class="row">
          <div class="col-md-6 offset-md-3">
            <div class="panel21 panel-default">

              <div class="panel-heading">
                  <h4 class="content-block labelAccordionForm">
                      <img src="../../assets/static/images/icons/gearwheels.png" class="formIcon"/>
                      SETTING
                  </h4>
              </div>

              <ul>
                <form-accordion open title="GENERAL">
                  <div class="form-group ">
                    <label class="col-form-label">Receive Modular Loan Email</label>
                    <label class="label-switch" :class="labelSwitchColorClass">
                      <input type="checkbox" class="checkboxSendPaymentsRequestEmail" @change="switchSendPaymentsRequestEmail" v-bind:value="sendPaymentRequestEmail">
                      <div class="checkbox"></div>
                    </label>
                  </div>
                  <div class="form-group ">
                    <label class="col-form-label">{{ $t('settings.activate_OCR') }}</label>
                    <label class="label-switch" :class="labelSwitchColorClass">
                      <input type="checkbox" class="checkboxOcrActivation" @change="changeSwitchOcrActivation" v-bind:value="ocrActivation">
                      <div class="checkbox"></div>
                    </label>
                  </div>
                  <div class="form-group ">
                    <label class="col-form-label">Generate Bank Transfer Order</label>
                    <label class="label-switch" :class="labelSwitchColorClass">
                      <input type="checkbox" class="checkboxIsToGenerateXML" @change="changeSwitchIsToGenerateXML" v-bind:value="isToGenerateXML">
                      <div class="checkbox"></div>
                    </label>
                  </div>
                  <div class="form-group ">
                    <label class="col-form-label">Validation amount</label>
                    <div class="item-after">{{validationThreshold}}</div>
                    <input class="range-slider-streammind" :class="sliderColorClass" type="range" min="0" max="15000" value="0" step="10" v-model="validationThreshold">
                  </div>
                </form-accordion>
              </ul>

              <hr>

              <ul>
                <form-accordion open title="PAYMENT METHOD">
                  <div class="form-group row">
                    <div class="form-group  col-sm-auto">
                      <div class="custom-control custom-radio custom-control-inline">
                        <input class="custom-control-input" id="defaultInline1" type="radio" name="methodRadio" value="application" v-model="paymentsMethod" checked>
                        <label class="custom-control-label" for="defaultInline1">Credit transfer</label>
                      </div>
                      <div class="custom-control custom-radio custom-control-inline">
                        <input class="custom-control-input" id="defaultInline2" type="radio" name="methodRadio" value="bankCard" v-model="paymentsMethod">
                        <label class="custom-control-label" for="defaultInline2">Bank card</label>
                      </div>
                    </div>
                  </div>
                </form-accordion>
              </ul>

              <!-- <hr>

              <ul>
                <form-accordion open title="NEGOTIATION">
                  <div class="form-group" style="margin-inline: initial;">
                    <label class="col-form-label">Activate Negotiation</label>
                    <label class="label-switch" :class="labelSwitchColorClass">
                      <input type="checkbox" class="checkboxNegotiationActivated" v-b-toggle="'collapse-2'" unchecked @change="switchNegotiationActivated" v-bind:value="negotiationActivated">
                      <div class="checkbox"></div>
                    </label>
                  </div>
                  <div class="form-group ">
                    <b-collapse visible id="collapse-2" class="mt-2">
                      <div class="form-group row">
                        <div class="col-md-4">
                          <label class="col-form-label">Negotiation threshold</label>
                        </div>
                        <div class="col-sm-auto">
                          <input class="form-control" type="number" onkeydown="return event.keyCode !== 69" placeholder="Negotiation threshold" value="">
                        </div>
                      </div>
                      <div class="form-group row">
                        <div class="col-md-4">
                          <label class="col-form-label">Installment number</label>
                        </div>
                        <div class="col-md-auto">
                          <select class="installmentSelect button-setting" v-model="defaultInstallmentNumber">
                            <option v-for="n in 6" :min="1" :value="n">{{n}}</option>
                          </select>
                        </div>
                      </div>
                    </b-collapse>
                  </div>
                </form-accordion>
              </ul> -->

              <hr>

              <ul>
                <form-accordion open title="Negotiation">
                  <div class="form-group">
                    <label class="col-form-label">Enable Installment Rules</label>
                    <label class="label-switch" :class="labelSwitchColorClass">
                      <input type="checkbox" v-model="enableInstallmentRules">
                      <div class="checkbox"></div>
                    </label>
                  </div>
                  <div class="form-group ">
                    <label class="col-form-label">Allow negotiation as default</label>
                    <label class="label-switch" :class="labelSwitchColorClass">
                      <input type="checkbox" class="checkboxDefaultNegotiationAllowed" @change="changeSwitchDefaultNegotiationAllowed" v-bind:value="defaultNegotiationAllowed">
                      <div class="checkbox"></div>
                    </label>
                  </div>
                  <div class="form-group">
                    <label class="col-form-label">Authorise contact to edit installments as default</label>
                    <label class="label-switch" :class="labelSwitchColorClass">
                      <input type="checkbox" v-model="defaultModificationInstallmentsAllowed">
                      <div class="checkbox"></div>
                    </label>
                  </div>
                </form-accordion>
              </ul>
            </div>
          </div>
        </div>
          <div class="row">
            <div class="col-md-2 offset-md-7" v-bind:class="colorBottomButton">
            <button round
            class="button-action firstButtonMarginTop"
            @click="changeApplicationSettings">
              <i class="icon fa fa-save"></i>
              <span>Save</span>
            </button>
            <div class="toolbarPageBottomBlank"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- </f7-page> -->
</template>

<script>
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {errorMessageAlert} from '@/helpers/alert'
// import {loadPage} from '@/helpers/routing'
import FormAccordion from '@/components/common/FormAccordion.vue'

export default {
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar,
    'form-accordion': FormAccordion
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      idSettingsApplication: '',
      defaultNegotiationAllowed: false,
      negotiationActivated: true,
      defaultInstallmentNumber: 1,
      ocrActivation: false,
      validationThreshold: 0,
      isToGenerateXML: false,
      sendPaymentRequestEmail: false,
      paymentsMethod: '',
      enableInstallmentRules: true,
      defaultModificationInstallmentsAllowed: true
    }
  },
  created () {
    if (this.$engine.services.directPayments.filter.smartphoneStorage) {
      this.isSmartphone = true
    }
  },
  computed: {
    sliderColorClass () {
      let fromIdServiceToSliderClass = {
        '1': 'RTP-slider',
        '2': 'DD-slider',
        '6': 'DP-slider'
      }
      return fromIdServiceToSliderClass[this.$engine.user.currentService.id]
    },
    labelSwitchColorClass () {
      let fromIdServiceToCheckboxClass = {
        '1': 'RTP-label-switch',
        '2': 'DD-label-switch',
        '6': 'DP-label-switch'
      }
      return fromIdServiceToCheckboxClass[this.$engine.user.currentService.id]
    }
  },
  mounted () {
    this.idSettingsApplication = this.$engine.settings.directDebit.get().idSettingsApplication
    this.defaultNegotiationAllowed = this.$engine.settings.directDebit.get().defaultNegotiationAllowed === '1'
    this.ocrActivation = this.$engine.settings.directDebit.get().ocrActivation === '1'
    this.validationThreshold = parseFloat(this.$engine.settings.directDebit.get().validationThreshold)
    this.paymentsMethod = this.$engine.settings.directDebit.get().paymentsMethod
    this.isToGenerateXML = this.$engine.settings.directDebit.get().isToGenerateXML === '1'
    this.sendPaymentRequestEmail = this.$engine.settings.directDebit.get().sendPaymentRequestEmail === '1'
    this.enableInstallmentRules = this.$engine.settings.directDebit.get().enableInstallmentRules === '1'
    this.defaultModificationInstallmentsAllowed = this.$engine.settings.directDebit.get().defaultModificationInstallmentsAllowed === '1'

    if (this.defaultNegotiationAllowed) {
      this.Dom7('.checkboxDefaultNegotiationAllowed').prop('checked', true)
    }
    if (this.ocrActivation) {
      this.Dom7('.checkboxOcrActivation').prop('checked', true)
    }
    if (this.isToGenerateXML) {
      this.Dom7('.checkboxIsToGenerateXML').prop('checked', true)
    }
    if (this.negotiationActivated) {
      this.Dom7('.checkboxNegotiationActivated').prop('checked', true)
      this.Dom7(this.Dom7('.checkboxNegotiationActivated')[this.Dom7('.checkboxNegotiationActivated').length - 1]).parent().parent().parent().parent().parent().parent().next().addClass('accordion-item-expanded')
    } else {
      this.Dom7(this.Dom7('.checkboxNegotiationActivated')[this.Dom7('.checkboxNegotiationActivated').length - 1]).parent().parent().parent().parent().parent().parent().next().removeClass('accordion-item-expanded')
    }
    if (this.sendPaymentRequestEmail) {
      this.Dom7('.checkboxSendPaymentsRequestEmail').prop('checked', true)
    }
  },
  methods: {
    switchNegotiationActivated (event) {
      let that = this
      this.negotiationActivated = event.target.checked
      if (this.negotiationActivated) {
        that.Dom7(event.target).parent().parent().parent().parent().parent().parent().next().addClass('accordion-item-expanded')
      } else {
        that.Dom7(event.target).parent().parent().parent().parent().parent().parent().next().removeClass('accordion-item-expanded')
      }
    },
    switchSendPaymentsRequestEmail (obj) {
      this.sendPaymentRequestEmail = obj.target.checked
    },
    switchEnableInstallmentRules (obj) {
      this.enableInstallmentRules = obj.target.checked
    },
    changeSwitchDefaultNegotiationAllowed (obj) {
      this.defaultNegotiationAllowed = obj.target.checked
    },
    changeSwitchOcrActivation (obj) {
      this.ocrActivation = obj.target.checked
    },
    changeSwitchIsToGenerateXML (obj) {
      this.isToGenerateXML = obj.target.checked
    },
    changeApplicationSettings () {
      let that = this
      let defaultNegotiationAllowedValue = this.defaultNegotiationAllowed === true ? '1' : '0'
      let ocrActivationValue = this.ocrActivation === true ? '1' : '0'

      this.paymentsMethod = that.Dom7('input[name=methodRadio]:checked').val()

      this.$engine.settings.directDebit.update({
        idSettingsApplication: that.idSettingsApplication,
        defaultNegotiationAllowed: defaultNegotiationAllowedValue,
        ocrActivation: ocrActivationValue,
        validationThreshold: that.validationThreshold,
        paymentsMethod: that.paymentsMethod,
        isToGenerateXML: that.isToGenerateXML === true ? '1' : '0',
        sendPaymentRequestEmail: that.sendPaymentRequestEmail === true ? '1' : '0',
        enableInstallmentRules: that.enableInstallmentRules === true ? '1' : '0',
        defaultModificationInstallmentsAllowed: that.defaultModificationInstallmentsAllowed === true ? '1' : '0'
      })
      .then(() => {
        that.$f7.modal({
          title: 'Application settings modified',
          text: '<span class="preloader"></span>'
        })
        setTimeout(function () {
          that.$f7.closeModal()
          that.idSettingsApplication = ''
          that.defaultNegotiationAllowed = false
          that.ocrActivation = false
          this.validationThreshold = 0
          this.paymentsMethod = 0
          that.sendPaymentRequestEmail = false
          /* loadPage(that, {url: '/settings/', force: false, ignoreCache: false}) */
        }, 2000)
      })
      .catch(err => {
        errorMessageAlert(err, this)
      })
    }
  }
}
</script>
<style>
.subOption {
  font-size: 14px;
}
.subOption input::-webkit-input-placeholder {
  font-size: 14px;
}
.container {
    /* margin-right: auto;
    margin-left: auto; */
    width: 100%;
    /* margin: 0 auto; */
}
.panel2, .panel21 {
    background: #fcfcfc;
    border: solid 1px #dbdbdb;
    /*margin-bottom: 5%;*/
    padding-bottom: 25px;
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    float: left;
    width: 100%;
}
* {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
}
a:hover {
    text-decoration: none;
}

.label-switch {
  float: right;
}

.no-bullets {
    list-style-type: none;
}
.mt-2 {
  width: 100%;
}
.inputFileButton {
  float: left;
}
.list-block {
    padding: 0px 0px 0px 0px;
    margin: auto;
    width: 100%
}

.button-setting {
  width: 80px;
}
ul {
  margin-left: -35px;
}
</style>



// WEBPACK FOOTER //
// CMDirectDebitSettingsPage.vue?249e066d